import { Flex } from '@chakra-ui/react';
import {
  Select,
  SelectValue,
  SelectTrigger,
  SelectItem,
  SelectContent,
  ChevronRight,
  Button as RabbitButton,
} from '@mesh.ai/rabbit';
import { LabelFieldWrapper } from 'screens/admin/Reviews/ReviewProcessV2Intent/components/LabelFieldWrapper';
import { SectionWrapper } from 'screens/admin/Reviews/ReviewProcessV2Intent/components/SectionWrapper';

import { Visibility } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';
import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

export const CompensationDeliverableSection = () => (
  <SectionWrapper
    title="Deliverables"
    subTitle="Required outcomes and documentation to be completed during the compensation cycle."
    rightComp={
      <Button
        target="_blank"
        as="a"
        variant="outlined"
        StartIcon={Visibility}
        startIconProps={{ boxSize: '16px' }}
        height="32px"
        href=""
      >
        Preview form
      </Button>
    }
  >
    <LabelFieldWrapper label="Result publishing permission" gridTemplateColumns="320px 1fr" gridGap={0}>
      <Select defaultValue="ADMIN_TO_EMPLOYEE">
        <SelectTrigger style={{ width: '400px' }}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent style={{ minWidth: 'fit-content' }}>
          <SelectItem value="ADMIN_TO_EMPLOYEE" style={{ paddingRight: '40px' }}>
            Admin publishes to employee
          </SelectItem>
          <SelectItem value="ADMIN_TO_MANAGER" style={{ paddingRight: '40px' }}>
            Admin published to manager who publishes to employee
          </SelectItem>
          <SelectItem value="ADMIN_MANAGER_TO_EMPLOYEE" style={{ paddingRight: '40px' }}>
            Admin/Manager published to employee
          </SelectItem>
        </SelectContent>
      </Select>
    </LabelFieldWrapper>
    <LabelFieldWrapper label="Compensation summary shared with" gridTemplateColumns="320px 1fr" gridGap={0}>
      <Select defaultValue="ALL_EMPLOYEES_AND_MANAGERS">
        <SelectTrigger style={{ width: '400px' }}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent style={{ minWidth: 'fit-content' }}>
          <SelectItem value="CHANGED_EMPLOYEES_AND_MANAGERS" style={{ paddingRight: '40px' }}>
            Only employees with a change and their manager
          </SelectItem>
          <SelectItem value="ALL_EMPLOYEES_AND_MANAGERS" style={{ paddingRight: '40px' }}>
            All employees and their manager
          </SelectItem>
          <SelectItem value="CHANGED_EMPLOYEES_ONLY" style={{ paddingRight: '40px' }}>
            Only employees with a change
          </SelectItem>
          <SelectItem value="ALL_EMPLOYEES" style={{ paddingRight: '40px' }}>
            All employees
          </SelectItem>
        </SelectContent>
      </Select>
    </LabelFieldWrapper>
    <LabelFieldWrapper label="Select compensation summary template" gridTemplateColumns="320px 1fr" gridGap={0}>
      <Flex
        flexDir="column"
        gap="8px"
        background="linear-gradient(180deg, #F5F7F9 0%, rgba(245, 247, 249, 0.00) 100%)"
        borderRadius="8px"
        border="1px solid"
        borderColor="border.EBEFF3"
        p="12px 12px 16px 12px"
        w="400px"
      >
        <Select value="OPTION_1">
          <SelectTrigger style={{ textAlign: 'left', padding: '0px', paddingBottom: '40px', width: '100%' }}>
            <SelectValue />
          </SelectTrigger>
          <SelectContent style={{ minWidth: 'fit-content' }}>
            <SelectItem value="OPTION_1" style={{ paddingRight: '40px' }}>
              <Flex flexDir="column" gap="4px">
                <TextBodyMedium>Compensation template 1</TextBodyMedium>
                <TextLabel color="text.g2">Includes salary, bonuses, benefits, incentives, and other perks</TextLabel>
              </Flex>
            </SelectItem>
          </SelectContent>
        </Select>
        <Flex align="center" justifyContent="space-between">
          <RabbitButton variant="text" size="small" iconRight={ChevronRight} style={{ padding: '0px' }}>
            Create new template
          </RabbitButton>
          <RabbitButton variant="text" size="small" iconRight={ChevronRight} style={{ padding: '0px' }}>
            Edit
          </RabbitButton>
        </Flex>
      </Flex>
    </LabelFieldWrapper>
  </SectionWrapper>
);
